module.exports = __webpack_public_path__ + "media/images/pages/fcr-flow/step-7-d630d8adec010062edf9af995099fca8.png";